const mockUser = {
  id: null,
  createdAt: null,
  updatedAt: null,
  archivedAt: null,
  initials: null,
  userName: null,
  firstName: null,
  lastName: null,
  displayName: null,
  email: null,
  phoneNumber: null,
  role: null,
  enableDebugLogs: false,
  userDisplayName: null,
  color: null
}

export default mockUser
